import { render, staticRenderFns } from "./CustomerPhotoUpload.vue?vue&type=template&id=d89023c4&scoped=true"
import script from "./CustomerPhotoUpload.vue?vue&type=script&lang=js"
export * from "./CustomerPhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomerPhotoUpload.vue?vue&type=style&index=0&id=d89023c4&prod&lang=stylus&scoped=true"
import style1 from "./CustomerPhotoUpload.vue?vue&type=style&index=1&id=d89023c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89023c4",
  null
  
)

export default component.exports